export default __webpack_public_path__ + "assets/images/b17cea532e5eeec2aa8da7021b560944.svg";